import { useNavigate } from "react-router-dom";
import { Order, statusStyles } from "../../types/orders";
import { Badge } from "src/components/ui/Badge";

const OrderSnippetCard = ({ orders }: { orders: Order[] }) => {
  const navigate = useNavigate();
  
  return (
    <div className="space-y-4">
      {Array.isArray(orders) && orders?.length === 0 ? (
        <div className="p-12 text-center bg-white rounded-3xl border border-dashed border-slate-200">
          <p className="text-slate-400 font-medium">
            All caught up! No new Orders.
          </p>
        </div>
      ) : (
        Array.isArray(orders) && orders?.map((order) => (
          <div
            className="flex items-center justify-between p-3 hover:bg-slate-50 rounded-xl transition-colors cursor-pointer border-b border-slate-200"
            onClick={() => navigate("/supplement/orders")}
          >
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center font-bold text-slate-600">
                {order.address.name[0]}
              </div>
              <div>
                <p className="text-sm font-bold text-slate-800">
                  {order.address.name}
                </p>
                <p className="text-xs text-slate-500">
                  {order.order_items?.length} {" "}
                  {order.order_items?.length === 1 ? "Item" : "Items"}
                </p>
              </div>
            </div>
            <Badge className={`${statusStyles[order.status]}`}>
              {order.status}
            </Badge>
            <span className="text-sm font-black text-emerald-600">
              ₹ {order.total_amount}
            </span>
          </div>
        ))
      )}
    </div>
  );
};

export default OrderSnippetCard;
